/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'fine' }, { id: 'medium' }, { id: 'thick' }, { id: 'veryThick' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-women-hair-thickness"
      progress={56}
      field="hairstyleWomenHairThickness"
      setter="setHairstyleWomenHairThickness"
      ns="hairstyleWomenHairThickness"
      options={OPTIONS}
    />
  );
}

export default Page;
